const getDefaultSortOption = (data) => {
    const form = data?.form || {};
    const sorters = form?.sorters || {};
    const orderByOptions = sorters?.orderByOptions || [];

    let selected = null;

    orderByOptions.map(order => {
        if (order.selected) {
            selected = order.name;
        }
    });

    return selected;
}

export default getDefaultSortOption;